// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-containers-Profile-WebAuthn-WebAuthnKey-styles--root--et5mS {
  display: flex;
  align-items: center;
}

.src-containers-Profile-WebAuthn-WebAuthnKey-styles--hint--gYAkF {
  margin-left: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/containers/Profile/WebAuthn/WebAuthnKey/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".root {\n  display: flex;\n  align-items: center;\n}\n\n.hint {\n  margin-left: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-containers-Profile-WebAuthn-WebAuthnKey-styles--root--et5mS`,
	"hint": `src-containers-Profile-WebAuthn-WebAuthnKey-styles--hint--gYAkF`
};
module.exports = ___CSS_LOADER_EXPORT___;
